import { render, staticRenderFns } from "./GuanLi.vue?vue&type=template&id=4d7a0aa6&scoped=true"
import script from "./GuanLi.vue?vue&type=script&lang=js"
export * from "./GuanLi.vue?vue&type=script&lang=js"
import style0 from "./GuanLi.vue?vue&type=style&index=0&id=4d7a0aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a0aa6",
  null
  
)

export default component.exports